
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/keyboard-nav-dialog/jst/KeyboardNavDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <li>\n    <span class=\"keycode\">";
  if (helper = helpers.key) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.key); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n    <span class=\"colon\">:</span>\n    <span class=\"description\">";
  if (helper = helpers.desc) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.desc); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</span>\n  </li>\n  ";
  return buffer;
  }

  buffer += "<ul class=\"navigation_list\" tabindex=\"-1\">\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.keyBindings), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</ul>\n<span>\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("keyboard_nav_dialog")
  },data:data},helper ? helper.call(depth0, "keyboard_nav_dialog.esc_key_notification", "Press the escape key before using keyboard shortcuts when navigating the gradebook grid.", options) : helperMissing.call(depth0, "t", "keyboard_nav_dialog.esc_key_notification", "Press the escape key before using keyboard shortcuts when navigating the gradebook grid.", options)))
    + "\n</span>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  